import { NavLink, useNavigate } from 'react-router-dom'
import { useModules, ModuleKey } from '../lib/modules'

const NAV: { to: string; icon: string; label: string; module?: ModuleKey }[] = [
  { to: '/manager/home',      icon: '🏠', label: 'Accueil' },
  { to: '/manager/planning',  icon: '📅', label: 'Planning' },
  { to: '/manager/badges',    icon: '🟢', label: 'Badges', module: 'badgeuse' },
  { to: '/manager/absences',  icon: '🌴', label: 'Congés', module: 'conges' },
  { to: '/manager/team',      icon: '👥', label: 'Équipe' },
]

export default function ManagerMobileLayout({ children }: { children: React.ReactNode }) {
  const nav = useNavigate()
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  const { modules } = useModules()

  function logout() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    nav('/manager/login')
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col max-w-lg mx-auto">
      <header className="bg-indigo-700 text-white px-4 py-3 flex items-center justify-between sticky top-0 z-10 shadow-md">
        <div>
          <div className="font-semibold">{user.firstName} {user.lastName}</div>
          <div className="text-indigo-200 text-xs capitalize">{user.role}</div>
        </div>
        <button onClick={logout} className="text-indigo-200 text-sm hover:text-white">
          Déconnexion
        </button>
      </header>

      <main className="flex-1 pb-20 overflow-y-auto">{children}</main>

      <nav className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-white border-t border-gray-200 flex z-10">
        {NAV.filter(item => !item.module || modules[item.module]).map(item => (
          <NavLink key={item.to} to={item.to}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center py-2 text-xs transition-colors ${isActive ? 'text-indigo-600' : 'text-gray-500 hover:text-gray-700'}`
            }>
            <span className="text-xl">{item.icon}</span>
            <span className="mt-0.5">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
